import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class SurveysProfilerError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('SurveysProfilerError', ...args);
    }
}
export default SurveysProfilerError;
